module.exports = __webpack_public_path__ + "img/logo-adam.78f28143.png";